import React, { useState } from 'react';
import DeleteIcon from '@material-ui/icons/Delete';
import ConfirmDialog from 'modules/ui/component/ConfirmDialog';
import { IconButton, Tooltip, TableCell } from '@material-ui/core';
import { showMessage } from 'app/store/fuse/messageSlice';
import { useDispatch } from 'react-redux';
import AdatlapService from '../service/AdatlapService';

function FeltoltesAdatlapDeleteButton(props) {
	const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
	const dispatch = useDispatch();

	const onDelete = () => {
		AdatlapService.deleteFolder(props.item.csomagNev, props.button.paperType, props.item.vizsgaAdatlap).then(resp => {
			if (resp) {
				dispatch(showMessage({ message: 'Sikeres lezárás.' }));
				dispatch({ type: `${props.config.key}/event/setNeedDataReload` });
			} else {
				dispatch(showMessage({ message: 'Hiba történt a lezárás végrehajtása során.' }));
			}
		});
		console.log(props.item);
	};

	return (
		<TableCell className="w-auto text-center" padding="none">
			<Tooltip title="Törlés">
				<span>
					<IconButton
						aria-label="delete"
						onClick={e => {
							setShowDeleteConfirm(true);
							e.preventDefault();
						}}
						disabled={props.item && props.item.protectionLevel && (props.item.protectionLevel === 'CannotBeDeleted' || props.item.protectionLevel === 'CannotBeModified')}
					>
						<DeleteIcon fontSize="small" />
					</IconButton>
				</span>
			</Tooltip>
			<ConfirmDialog show={showDeleteConfirm} title="Törlés" description="Biztosan törli a kiválasztott tételt?" onYes={() => onDelete()} onClose={() => setShowDeleteConfirm(false)} />
		</TableCell>
	);
}

export default FeltoltesAdatlapDeleteButton;
